// extracted by mini-css-extract-plugin
export default {"container":"style_container__hXT6f","card":"style_card__Mp1wH","row":"style_row__TuFSU","btnsRow":"style_btnsRow__FFcOH"};